<template>
    <div class="card">
        <div class="card-body">
        <h4 v-if="orderLines" class="card-title">Order regels ({{orderLines.length}})</h4>
        <h4 v-else class="card-title">Order regels</h4>
        <div v-if="orderLines">
            <div v-for="orderLine in orderLines" v-bind:key="orderLine.id">
                <hr/>
                <b-row>
                    <b-col md="12">
                        <b-row>
                            <b-col sm="12" md="6" lg="6" xl="5">
                                <small class="text-muted">Artikel</small>
                                <h6 v-if="orderLine.articleDescription">
                                    {{orderLine.articleNumber}} - {{orderLine.articleDescription}} {{orderLine.color != '' ? '('+orderLine.color+')' : ''}}</h6> 
                                <h6 v-else>Niet van toepassing</h6>
                            </b-col>
                            <b-col sm="12" md="6" lg="6" xl="3">
                                <small class="text-muted">Kwaliteitsnaam &amp; kleur</small>
                                <h6 v-if="orderLine.qualityName">{{orderLine.qualityName}}</h6> 
                                <h6 v-else>Niet van toepassing</h6>           
                            </b-col>
                            <b-col sm="12" md="6" lg="6" xl="2">
                                <small class="text-muted">Afmetingen</small>
                                <h6 v-if="orderLine.sizes">{{orderLine.sizes}} cm</h6>   
                                <h6 v-else>Niet opgegeven</h6>         
                            </b-col>
                            <b-col sm="12" md="6" lg="6" xl="2">
                                <small class="text-muted">Aantal</small>
                                <h6 v-if="orderLine.quantity">{{orderLine.quantity}}</h6>   
                                <h6 v-else>Niet opgegeven</h6>           
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div v-else>
            <content-placeholders>
                <content-placeholders-heading/>
                <content-placeholders-text :lines="2"/>
            </content-placeholders>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'order-lines',
    props: ['orderLines']
}

</script>